export default "__VITE_ASSET__ec815116__"